<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <md-card class="card" style="margin: 1rem">
      <md-card-content>
        <md-layout md-gutter style="position: relative !important">
          <md-layout md-flex="10" style="z-index: 999">
            <md-button class="
                md-raised md-primary md-button-color md-theme-default
                back
                heght-1px
              " @click="previousFFView">&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="100" class="justify-content-center" style="position: absolute">
            <h2 style="text-align: center">Assignment Notes</h2>
          </md-layout>
        </md-layout>
        <!-- <b-button
          md-flex="100"
          style="font-size: 0.675rem"
          @click="UpdateMessageStatusModal()"
          size="sm"
          class="pull-right"
          variant="warning"
          >Update Status</b-button
        > -->
        <hr class="hr-s" />

        <div class="row">
          <!-- Internal CHAT Start-->
          <div class="col-md-12">
            <div class="box box-warning direct-chat direct-chat-warning">
              <div class="box-header with-border">
                <h3 class="box-title">Internal Chat</h3>
              </div>
              <div class="box-body" style="border: 1px solid #e7e7e7">
                <div class="direct-chat-messages" id="internalChat">
                  <ul style="padding: 0; margin: 0" v-for="(item, index) in internalChat2" :key="index + '_chat'">
                    <div class="direct-chat-msg">
                      <div class="direct-chat-info clearfix">
                        <span class="direct-chat-name pull-left">Assigned By : {{ item.employeeName }}</span>
                        <!-- {{item}} -->
                        <span class="direct-chat-timestamp pull-right">{{
                          item.loginTime | moment
                          }}</span>
                      </div>
                      <md-icon class="md-size-2x nav-icon">person_outline</md-icon>
                      <div class="direct-chat-text">
                        {{ item.remarkMsg }}

                        <!-- <b-form-radio
                          v-model="selected"
                          :id="index + '-chat-id'"
                          :value="item.value"
                          :disabled="item.value == '2' ? true : false"
                          name="some-radios"
                          @change="UpdateMessageStatus(item.taskId, '2')"
                        >
                          Completed
                        </b-form-radio>
                        {{ selected }} -->
                      </div>
                      <b-form-checkbox :v-model="item.flage?true:false" :disabled="item.value == '2' ? true : false"
                        name="check-button" @change="UpdateMessageStatus(item.taskId, '2')" switch>
                        <b v-if="item.value == '2'">Completed </b>&nbsp;&nbsp;
                        <span class="direct-chat-timestamp pull-right"
                          v-if="item.msg_status_updated">{{""+item.msg_status_updated}}</span>
                      </b-form-checkbox>
                      <span class="direct-chat-name pull-left" v-if="item.assignedUsersName != ''">Assigned To : {{
                        item.assignedUsersName }}</span>

                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Internal CHAT End-->

          <!-- Client CHAT Start-->
          <!-- <div class="col-md-6" v-if="this.jsonObj.login!='portLogin'">
            <div class="box box-warning direct-chat direct-chat-warning">
              <div class="box-header with-border">
                <h3 class="box-title">Client Chat</h3>
              </div>
              <div class="box-body" style="border:1px solid #e7e7e7">
                <div class="direct-chat-messages" id="your_div">
                  <ul style="padding:0;margin:0" v-for="(item,index) in clientChat" :key="index">
                    <div class="direct-chat-msg" v-bind:class="item.clientId=='0'?'right':''">
                      <div class="direct-chat-info clearfix">
                        <span
                          class="direct-chat-name"
                          v-bind:class="item.clientId=='0'?'pull-right':'pull-left'"
                        >{{item.clientId=='0'?item.employeeName:item.clientName}}</span>
                        <span
                          class="direct-chat-timestamp"
                          v-bind:class="item.clientId=='0'?'pull-left':'pull-right'"
                        >{{item.loginTime | moment}}</span>
                      </div>
                      <img
                        class="direct-chat-img"
                        src="https://image.flaticon.com/icons/svg/149/149452.svg"
                        alt="message user image"
                      />
                      <div class="direct-chat-text">{{item.remarkMsg}}</div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>

          </div> -->

          <!-- Client CHAT End-->
        </div>
        <hr class="hr-s" />
        <md-layout md-gutter>
          <md-layout md-flex="50" class="pr-4">
            <label for="type">Internal</label>
            <model-list-select :isDisabled="true" option-value="typeV" option-text="typeT" :list="typeList"
              placeholder="Select " v-model="updateModal.msgType"></model-list-select>
            <span class="error" v-if="!updateModal.msgType">{{
              errorDocModal.msgType
              }}</span>
          </md-layout>
          <!-- <md-layout md-flex="50" class="pr-4" v-if="assignedUsersName">
            <label for="blType">Task Status</label>
            <model-list-select
              :list="categoryTypeList"
              v-model="updateModal.taskStatus"
              option-value="categoryTypeVal"
              option-text="categoryTypeTxt"
              placeholder="Select Status"
            ></model-list-select>
          </md-layout> -->

          <!-- <md-layout md-flex="50" class="pl-4">
            <label for="type">Assignment Status</label>
            <model-list-select
              option-value="statusV"
              option-text="statusT"
              :list="statusList"
              placeholder="Select Status "
              v-model="updateModal.status"
            ></model-list-select>
            <span class="error" v-if="!updateModal.status">{{
              errorDocModal.status
            }}</span>
          </md-layout> -->
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="100">
            <md-layout md-flex="100">
              <label for="itemDescription">Message</label>

              <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark" v-model="updateModal.remarkMsg"
                row="5"></b-form-textarea>
              <span class="error" v-if="!updateModal.remarkMsg">{{
                errorDocModal.remarkMsg
                }}</span>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <md-layout md-flex="100" class="justify-content-center mt-2">
            <md-button class="
                md-raised md-primary md-button-color md-theme-default
                back
                heght-1px
              " id="addButtonLoader1" @click="sendUpdate">Send</md-button>
            <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <div class="gutr"></div>

    <b-modal id="UpdateMessageStatusModal-modal" ref="UpdateMessageStatusModal-modal" title="Update Message Status"
      size="xl" no-close-on-esc no-close-on-backdrop hide-footer>
      <div class="row">
        <div class="col-md-6">
          <model-list-select :list="taskMSGMaster" id="taskMSGId" v-model="updateMSGStatus.taskMSGId"
            option-value="taskId" option-text="taskTitle" placeholder="Select Task Title">
          </model-list-select>
          <span class="error" v-if="!updateMSGStatus.taskMSGId">{{
            errorupdateMSGStatus.taskMSGId
            }}</span>
        </div>
        <div class="col-md-6">
          <model-list-select :list="categoryTypeList" v-model="updateMSGStatus.taskStatus"
            option-value="categoryTypeVal" option-text="categoryTypeTxt"
            placeholder="Select Status"></model-list-select>
          <span class="error" v-if="!updateMSGStatus.taskStatus">{{
            errorupdateMSGStatus.taskStatus
            }}</span>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4 text center mb-2">
          <b-button class="mt-2" variant="success" @click="UpdateMessageStatus()">Update</b-button>
          <b-button class="mt-2" @click="hideUpdateMessageStatusModal" variant="danger">Close</b-button>
        </div>
        <div class="col-md-4"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    console.log("MessageStatus=>", this.$sessionsStorage.get("MessageStatus"));
    this.jsonObj = JSON.parse(this.$sessionsStorage.get("MessageStatus"));
    console.log("this.jsonObj=>", this.jsonObj);
    if (this.jsonObj != "" && this.jsonObj != null) {
      this.$store.dispatch("setCurrentRoute", "/UpdateMessage/allMessageForm");
      this.getData("2");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      selected: "2",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      assignedUsersName: "",
      assignedUsers: "",
      jsonObj: {},
      updateModal: {
        taskId: null,
        remarkMsg: "",
        msgType: "2",
        taskStatus: "",
        // status: "",
      },
      taskMSGMaster: [],
      updateMSGStatus: {
        taskMSGId: "",
        taskStatus: "",
      },
      errorupdateMSGStatus: {
        taskMSGId: "",
        taskStatus: "",
      },
      errorMSG: ["Select Message", "Select Status"],
      statusList: [
        {
          statusV: "1",
          statusT: "In-Progress",
        },
        {
          statusV: "2",
          statusT: "Completed",
        },
        {
          statusV: "3",
          statusT: "Pending Due to Errors",
        },
      ],
      categoryTypeList: [
        {
          categoryTypeVal: "0",
          categoryTypeTxt: "Pending",
        },
        // {
        //   categoryTypeVal: "1",
        //   categoryTypeTxt: "In-Progress",
        // },
        {
          categoryTypeVal: "2",
          categoryTypeTxt: "Completed",
        },
        // {
        //   categoryTypeVal: "3",
        //   categoryTypeTxt: "Raise Query",
        // },
      ],
      clientChat: [],
      internalChat: [],
      internalChat2: [],
      typeList: [
        // {
        //   typeV: "1",
        //   typeT: "Client",
        // },
        {
          typeV: "2",
          typeT: "Internal",
        },
      ],
      errorDocModal: {
        msgType: "",
        status: "",
        remarkMsg: "",
      },
      validate: true,
      isLoading: false,
      designation: "",
      departmentName: "",
      MessageStatus: JSON.parse(this.$sessionsStorage.get("MessageStatus")),

      AirImportData: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return moment(date).format(" Do MMM 'YY  H:m");
    },
  },

  beforeDestroy() {
    // this.$sessionsStorage.set("MessageStatus", "");
  },

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
  },

  computed: {},

  methods: {
    UpdateMessageStatusModal() {
      this.$refs["UpdateMessageStatusModal-modal"].show();
    },
    hideUpdateMessageStatusModal() {
      this.$refs["UpdateMessageStatusModal-modal"].hide();
    },
    validateUpdateMSGSend() {
      let validate_new = true;

      Object.keys(this.errorupdateMSGStatus).map((x, index) => {
        if (this.updateMSGStatus[x] == "") {
          this.errorupdateMSGStatus[x] = this.errorMSG[index];

          validate_new = false;
        } else {
          this.errorupdateMSGStatus[x] = "";
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    UpdateMessageStatus(taskId, status) {
      // this.validateUpdateMSGSend();

      let updateMSGStatus = {
        taskMSGId: taskId,
        taskStatus: status,
      };
      if (taskId != "") {
        // if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/updateTaskMSG.php`,
          data: JSON.stringify(updateMSGStatus),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");
              this.updateMSGStatus.taskMSGId = "";
              this.updateMSGStatus.taskStatus = "";
              this.$refs["UpdateMessageStatusModal-modal"].hide();
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.getData("2");
            }
          })
          .catch((error) => {});
      }
    },
    validateSend() {
      let validate_new = true;

      Object.keys(this.errorDocModal).map((x, index) => {
        if (this.updateModal[x] == "") {
          this.errorDocModal[x] = this.errorDo[index];

          validate_new = false;
        } else {
          this.errorDocModal[x] = "";
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    sendUpdate() {
      this.validateSend();

      Object.keys(this.MessageStatus).map((x) => {
        this.updateModal[x] = this.MessageStatus[x];
      });

      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/addallMessage.php`,
          data: JSON.stringify(this.updateModal),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");
              this.updateModal.remarkMsg = "";
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.getData("2");
            }
          })
          .catch((error) => {});
      }
    },
    previousFFView() {
      window.history.go(-1);
    },

    getData(id) {
      //   if (id == "2") {
      //     this.isLoading = true;
      //   }

      let payload = JSON.parse(this.$sessionsStorage.get("MessageStatus"));

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getallMessageList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.internalChat2= [],
            console.log("data=>", data);
            // this.updateModal.status = this.MessageStatus.statusMain;
            if (data.messageList.length > 0) {
              //   let array1 = data.messageList.filter((x) => {
              //     return x.msgType == "1";
              //   });
              //   if (array1.length > 0) {
              //     this.clientChat = array1;
              //   }
              let array2 = data.messageList.filter((x) => {
                // alert(x.msg_type);
                return x.msg_type == "2";
              });
              this.taskMSGMaster = [];
              if (array2.length > 0) {
                this.internalChat = array2;

                this.assignedUsers = data.assignedUsers;
                this.assignedUsersName = data.assignedUsersName;

                this.internalChat.forEach((element) => {
                  if (element.taskStatus == "0") {
                    element["text"] = "Pending";
                    element["flage"] = false;
                  } else if (element.taskStatus == "1") {
                    element["text"] = "In-Progress";
                    element["flage"] = false;
                  } else if (element.taskStatus == "2") {
                    element["text"] = "Completed";
                    element["flage"] = true;
                  } else {
                    element["text"] = "Query Raised";
                    element["flage"] = false;
                  }
                  element["value"] = element.taskStatus;
                  element["taskId"] = element.taskId;
                  element["taskTitle"] = element.taskTitle;
                  element["fk_all_module_id"] = element.taskRemarks;
                  element["fk_all_module_id"] = element.fk_all_module_id;
                  element["fk_client_id"] = element.fk_client_id;
                  element["fk_pod_id"] = element.fk_pod_id;
                  element["assignedUsers"] = element.assignedUsers;
                  element["assignedUsersName"] = element.assignedUsersName;
                  element["firstSeenByUserId"] = element.firstSeenByUserId;
                  element["firstSeenByUserDate"] = element.firstSeenByUserDate;
                  element["loginTime"] = element.loginTime;
                  element["msg_type"] = element.msg_type;
                  element["remarkMsg"] = element.remarkMsg;
                  element["pod_id"] = element.pod_id;
                  element["allModuleId"] = element.allModuleId;
                  element["employeeName"] = element.employeeName;
                  element["client_id"] = element.client_id;
                  element["clientName"] = element.clientName;
                  this.internalChat2.push(element);
                });
                // element["doc_id"] = element.doc_id;
                // this.internalChat.forEach((element) => {
                //   let obj = {
                //     taskId: element.taskId,
                //     taskTitle: element.taskTitle,
                //     value:item.taskStatus,
                //     text:'Completed',
                //   };
                //   this.taskMSGMaster.push(obj);
                //   i++;
                // });
                let i = 0;
                array2.forEach((element) => {
                  let obj = {
                    taskId: element.taskId,
                    taskTitle: element.taskTitle,
                  };
                  this.taskMSGMaster.push(obj);
                  i++;
                });
              }

              console.log("this.internalChat=>", this.internalChat);
              console.log("this.internalChat2=>", this.internalChat2);
            }
            if (this.jsonObj.login != "portLogin") {
              $("#your_div").animate(
                {
                  scrollTop: $("#your_div").get(0).scrollHeight + 10000,
                },
                1000
              );
            }

            if (this.jsonObj.login != "portLogin") {
              $("#internalChat").animate(
                {
                  scrollTop: $("#your_div").get(0).scrollHeight + 10000,
                },
                1000
              );
            }
            // if (id == "2") {
            //   this.isLoading = false;
            // }
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// allMessageForm.vue?1560bf1c